
          export {
            global,
Buffer,
process
          } from '@dxos/node-std/inject-globals';
          // Empty source map so that esbuild does not inject virtual source file names.
          //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIiJdLCJtYXBwaW5ncyI6IkEifQ==
        